import React, { useEffect, useState } from 'react'
import './footer.css'
import { Link } from 'react-router-dom'
import { AiOutlineInstagram, AiOutlineFacebook, AiOutlineTwitter, AiOutlineYoutube, AiOutlineGoogle } from 'react-icons/ai'
import axios from 'axios'
import key from '../../key'


const Footer = () => {
  const [facebookLink, setFacebookLink] = useState('');
  const [instagramLink, setInstagramLink] = useState('');
  const [twitterLink, setTwitterLink] = useState('');
  const [youtubeLink, setYoutubeLink] = useState('');
  const [googleLink, setGoogleLink] = useState('');
  const getSiteSettings = async () => {
    await axios.get(`${key}/api/admin/get-site-settings`)
      .then((res) => {
        setFacebookLink(res?.data?.setting?.facebook);
        setInstagramLink(res?.data?.setting?.instagram);
        setTwitterLink(res?.data?.setting?.twitter);
        setYoutubeLink(res?.data?.setting?.youtube);
        setGoogleLink(res?.data?.setting?.google);
      })
      .catch((err) => console.log(err));
  }
  useEffect(() => {

    getSiteSettings();
    //eslint-disable-next-line
  }, [])
  return (
    <div className='footer'>
      <div className="footer-main d-flex justify-content-between">
        <div className="footer-left">
          <div className="footer-left-heading">Lovodi.com</div>
          <div className="footer-left-links">
            <Link to='/'>Home</Link>
            <Link to='/contact-us'>Contact Us</Link>
            <Link to='/about-us'>About Us</Link>
            <Link to='/terms-conditions'>Terms & Conditions</Link>
            <Link to='/privacy-policy'>Privacy Policy</Link>
          </div>
        </div>
        <div className='social-media-icons'>
          <Link to={facebookLink}><AiOutlineFacebook /></Link>
          <Link to={instagramLink}><AiOutlineInstagram /></Link>
          <Link to={twitterLink}><AiOutlineTwitter /></Link>
          <Link to={youtubeLink}><AiOutlineYoutube /></Link>
          <Link to={googleLink}><AiOutlineGoogle /></Link>
        </div>
        <div>
          <div className='aliRaza'>Designed & Developed by <Link target="_blank" to="https://www.linkedin.com/in/alirazahub/">alirazahub</Link></div>
          <div className="copy-right">© 2023 Lovodi.com - The World's No.1 Matchmaking Service™</div>
        </div>
      </div>
    </div>
  )
}

export default Footer
